import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../assets/calendarOverviewTop400.png'
import _imports_1 from '../assets/calendarOverviewTop400Free_2.png'
import _imports_2 from '../assets/todoOverviewTop.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Willkommen auf der Startseite vom CASA", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-weight-bold ms-1 mb-2" }, " Today ", -1)
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "font-weight-normal" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-weight-normal" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Heute stehen keine Termine an. ☀️🏖️")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "font-weight-bold ms-1 mb-2" }, " Nächste 7 Tage ", -1)
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "font-weight-normal" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-weight-normal" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "In den nächsten 7 Tagen sind keine Termine. ☀️🏖️")
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "font-weight-bold ms-1 mb-2" }, " Today ", -1)
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { class: "font-weight-normal" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-weight-normal" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Heute stehen keine Todos an. ☀️🏖️")
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "font-weight-bold ms-1 mb-2" }, " Nächste 7 Tage ", -1)
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = { class: "font-weight-normal" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-weight-normal" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "In den nächsten 7 Tagen stehen keine Todos an. ☀️🏖️")
  ])
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "font-weight-bold ms-1 mb-2" }, " Bewerbungen ", -1)
const _hoisted_19 = { class: "mb-4" }
const _hoisted_20 = { class: "font-weight-normal" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-weight-normal" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Es stehen keine Bewerber an. ☀️🏖️")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_snackbar = _resolveComponent("error-snackbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_timeline = _resolveComponent("v-timeline")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_error_snackbar, {
      snackbar: _ctx.errorSnackbar,
      "onUpdate:snackbar": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.errorSnackbar) = $event))
    }, null, 8, ["snackbar"]),
    _createVNode(_component_v_row, {
      justify: "space-around",
      class: "mt-2"
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_v_divider, { class: "border-opacity-50" })
      ]),
      _: 1
    }),
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              md: "12",
              lg: "3",
              mb: "4",
              class: "mr-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  width: "400",
                  class: "ml-2 mt-4"
                }, {
                  default: _withCtx(() => [
                    (_ctx.EventsToday.length > 0)
                      ? (_openBlock(), _createBlock(_component_v_img, {
                          key: 0,
                          height: "157",
                          src: _imports_0,
                          cover: "",
                          class: "text-white"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar, {
                              color: "rgba(0, 0, 0, 0)",
                              theme: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_toolbar_title, {
                                  class: "text-h6",
                                  style: {"font-color":"black"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Heutige Termine ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_img, {
                          key: 1,
                          height: "157",
                          src: _imports_1,
                          cover: "",
                          class: "text-white"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar, {
                              color: "rgba(0, 0, 0, 0)",
                              theme: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Heutige Termine ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _hoisted_2,
                        (_ctx.EventsToday.length > 0)
                          ? (_openBlock(), _createBlock(_component_v_timeline, {
                              key: 0,
                              density: "compact",
                              align: "start"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.EventsToday, (event) => {
                                  return (_openBlock(), _createBlock(_component_v_timeline_item, {
                                    key: _ctx.formatDateCalPreview(event.start),
                                    "dot-color": event.color,
                                    size: "x-small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                          _createElementVNode("strong", null, [
                                            _createTextVNode(_toDisplayString(_ctx.isUserAssigned(event.assigned_to)) + " ", 1),
                                            (Object.keys(event.assigned_to).length > 1)
                                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                                  key: 0,
                                                  size: "x-small",
                                                  class: "ma-2"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString('+' + (Object.keys(event.assigned_to).length - 1)), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createTextVNode(" @" + _toDisplayString(_ctx.formatDateCalPreview(event.start)) + " ", 1),
                                          (Object.keys(event.assigned_to).length > 1)
                                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                key: 0,
                                                activator: "parent",
                                                location: "top"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.assigned_to, (user) => {
                                                    return (_openBlock(), _createBlock(_component_v_chip, {
                                                      variant: "text",
                                                      key: user.user_id
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(user.username), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", null, _toDisplayString(event.title), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["dot-color"]))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_timeline, {
                              key: 1,
                              density: "compact",
                              align: "start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_timeline_item, {
                                  "dot-color": "#00000",
                                  size: "x-small"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_5
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, {
                  width: "400",
                  class: "ml-2 mt-5"
                }, {
                  default: _withCtx(() => [
                    (_ctx.Events7Days.length > 0)
                      ? (_openBlock(), _createBlock(_component_v_img, {
                          key: 0,
                          height: "157",
                          src: _imports_0,
                          cover: "",
                          class: "text-white"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar, {
                              color: "rgba(0, 0, 0, 0)",
                              theme: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Termine der nächsten 7 Tage ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_img, {
                          key: 1,
                          height: "157",
                          src: _imports_1,
                          cover: "",
                          class: "text-white"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar, {
                              color: "rgba(0, 0, 0, 0)",
                              theme: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Termine der nächsten 7 Tage ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _hoisted_6,
                        (_ctx.Events7Days.length > 0)
                          ? (_openBlock(), _createBlock(_component_v_timeline, {
                              key: 0,
                              density: "compact",
                              align: "start"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Events7Days, (event) => {
                                  return (_openBlock(), _createBlock(_component_v_timeline_item, {
                                    key: event.start,
                                    "dot-color": event.color,
                                    size: "x-small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, [
                                          _createElementVNode("strong", null, [
                                            _createTextVNode(_toDisplayString(_ctx.isUserAssigned(event.assigned_to)) + " ", 1),
                                            (Object.keys(event.assigned_to).length > 1)
                                              ? (_openBlock(), _createBlock(_component_v_chip, {
                                                  key: 0,
                                                  size: "x-small",
                                                  class: "ma-2"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString('+' + (Object.keys(event.assigned_to).length - 1)), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createTextVNode(" @" + _toDisplayString(_ctx.formatDateCalPreview(event.start)) + " - " + _toDisplayString(_ctx.formatDateToDDMMYYYY(_ctx.formatDate(event.start, false, true))) + " ", 1),
                                          (Object.keys(event.assigned_to).length > 1)
                                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                key: 0,
                                                activator: "parent",
                                                location: "top"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.assigned_to, (user) => {
                                                    return (_openBlock(), _createBlock(_component_v_chip, {
                                                      variant: "text",
                                                      key: user.user_id
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(user.username), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  }), 128))
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", null, _toDisplayString(event.title), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["dot-color"]))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_timeline, {
                              key: 1,
                              density: "compact",
                              align: "start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_timeline_item, {
                                  "dot-color": "#00000",
                                  size: "x-small"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_9
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "12",
              lg: "3",
              mb: "4",
              class: "mr-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  width: "400",
                  class: "ml-8 mt-4"
                }, {
                  default: _withCtx(() => [
                    (_ctx.TodosToday.length > 0)
                      ? (_openBlock(), _createBlock(_component_v_img, {
                          key: 0,
                          height: "157",
                          src: _imports_2,
                          cover: "",
                          class: "text-white"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar, {
                              color: "rgba(0, 0, 0, 0)",
                              theme: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_toolbar_title, {
                                  class: "text-h6",
                                  style: {"font-color":"black"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Heutige Todos ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_img, {
                          key: 1,
                          height: "157",
                          src: _imports_1,
                          cover: "",
                          class: "text-white"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar, {
                              color: "rgba(0, 0, 0, 0)",
                              theme: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Heutige Todos ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        (_ctx.TodosToday.length > 0)
                          ? (_openBlock(), _createBlock(_component_v_timeline, {
                              key: 0,
                              density: "compact",
                              align: "start"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TodosToday, (todo) => {
                                  return (_openBlock(), _createBlock(_component_v_timeline_item, {
                                    key: todo.id,
                                    "dot-color": _ctx.getDotColor(todo.importance),
                                    size: "x-small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, [
                                          _createElementVNode("strong", null, _toDisplayString(todo.MainTodo), 1),
                                          _createTextVNode(" @ " + _toDisplayString(todo.SubTodo), 1)
                                        ]),
                                        _createElementVNode("div", null, _toDisplayString(todo.TodoPoint), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["dot-color"]))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_timeline, {
                              key: 1,
                              density: "compact",
                              align: "start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_timeline_item, {
                                  "dot-color": "#00000",
                                  size: "x-small"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_13
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, {
                  width: "400",
                  class: "ml-8 mt-5"
                }, {
                  default: _withCtx(() => [
                    (_ctx.Todos7Days.length > 0)
                      ? (_openBlock(), _createBlock(_component_v_img, {
                          key: 0,
                          height: "157",
                          src: _imports_2,
                          cover: "",
                          class: "text-white"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar, {
                              color: "rgba(0, 0, 0, 0)",
                              theme: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_toolbar_title, {
                                  class: "text-h6",
                                  style: {"font-color":"black"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Todos in den nächsten 7 Tagen. ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_img, {
                          key: 1,
                          height: "157",
                          src: _imports_1,
                          cover: "",
                          class: "text-white"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar, {
                              color: "rgba(0, 0, 0, 0)",
                              theme: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Todos der nächsten 7 Tage ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _hoisted_14,
                        (_ctx.Todos7Days.length > 0)
                          ? (_openBlock(), _createBlock(_component_v_timeline, {
                              key: 0,
                              density: "compact",
                              align: "start"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Todos7Days, (todo) => {
                                  return (_openBlock(), _createBlock(_component_v_timeline_item, {
                                    key: todo.id,
                                    "dot-color": _ctx.getDotColor(todo.importance),
                                    size: "x-small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                          _createElementVNode("strong", null, _toDisplayString(todo.MainTodo), 1),
                                          _createTextVNode(" @ " + _toDisplayString(todo.SubTodo), 1)
                                        ]),
                                        _createElementVNode("div", null, _toDisplayString(todo.TodoPoint), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["dot-color"]))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_timeline, {
                              key: 1,
                              density: "compact",
                              align: "start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_timeline_item, {
                                  "dot-color": "#00000",
                                  size: "x-small"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_17
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "6",
              lg: "3",
              mb: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  width: "400",
                  class: "ml-8 mt-4"
                }, {
                  default: _withCtx(() => [
                    (_ctx.Applicants.length > 0)
                      ? (_openBlock(), _createBlock(_component_v_img, {
                          key: 0,
                          height: "157",
                          src: _imports_2,
                          cover: "",
                          class: "text-white"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar, {
                              color: "rgba(0, 0, 0, 0)",
                              theme: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_toolbar_title, {
                                  class: "text-h6",
                                  style: {"font-color":"black"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Ausstehende Bewerbungen ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_img, {
                          key: 1,
                          height: "157",
                          src: _imports_1,
                          cover: "",
                          class: "text-white"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar, {
                              color: "rgba(0, 0, 0, 0)",
                              theme: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Ausstehende Bewerbungen ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _hoisted_18,
                        (_ctx.Applicants.length > 0)
                          ? (_openBlock(), _createBlock(_component_v_timeline, {
                              key: 0,
                              density: "compact",
                              align: "start"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Applicants, (Applicant) => {
                                  return (_openBlock(), _createBlock(_component_v_timeline_item, {
                                    key: Applicant.id,
                                    "dot-color": "green",
                                    size: "x-small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("div", _hoisted_20, [
                                          _createElementVNode("strong", null, _toDisplayString(Applicant.name), 1),
                                          _createTextVNode(" @" + _toDisplayString(Applicant.jobinterviewTime.substring(0,5)) + " - " + _toDisplayString(_ctx.formatDateToDDMMYYYY(Applicant.jobinterviewDate)), 1)
                                        ]),
                                        _createElementVNode("div", null, _toDisplayString(Applicant.email) + ", " + _toDisplayString(Applicant.phonenumber), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_timeline, {
                              key: 1,
                              density: "compact",
                              align: "start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_timeline_item, {
                                  "dot-color": "#00000",
                                  size: "x-small"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_21
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}